/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Icon2IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Icon2Icon(props: Icon2IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 28 28"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <mask
        id={"a"}
        width={"28"}
        height={"28"}
        x={"0"}
        y={"0"}
        maskUnits={"userSpaceOnUse"}
        style={{
          maskType: 'alpha"'
        }}
      >
        <path fill={"#D9D9D9"} d={"M0 0h28v28H0z"}></path>
      </mask>

      <g mask={"url(#a)"}>
        <path
          fill={"#6D28D9"}
          d={
            "M13.327 21.73h1.75v-1.167h1.458a.85.85 0 0 0 .624-.252.85.85 0 0 0 .251-.623v-3.5a.85.85 0 0 0-.251-.624.85.85 0 0 0-.624-.251h-3.792v-1.75h4.667v-1.75h-2.333v-1.167h-1.75v1.167h-1.459a.85.85 0 0 0-.623.251.85.85 0 0 0-.252.624v3.5q0 .372.252.623a.85.85 0 0 0 .624.252h3.791v1.75h-4.667v1.75h2.334zm-5.968 3.354q-.884 0-1.497-.613a2.04 2.04 0 0 1-.612-1.496V5.026q0-.884.612-1.497a2.04 2.04 0 0 1 1.497-.612h9.266l6.125 6.125v13.933q0 .884-.613 1.496a2.04 2.04 0 0 1-1.496.613zM15.75 9.199V4.667H7.359a.34.34 0 0 0-.247.112.34.34 0 0 0-.112.247v17.949q0 .135.112.246a.34.34 0 0 0 .247.113h13.282q.135 0 .247-.113a.34.34 0 0 0 .112-.246V9.199z"
          }
        ></path>
      </g>
    </svg>
  );
}

export default Icon2Icon;
/* prettier-ignore-end */
